// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mongosh-shell-input-shell-input__IkOW_ {\n  padding: 0 8px;\n  min-height: 24px;\n}\n", ""]);
// Exports
exports.locals = {
	"shell-input": "mongosh-shell-input-shell-input__IkOW_"
};
module.exports = exports;
